import { defineMessage, defineMessages, MessageDescriptor } from 'react-intl'

import { CONNECTED_SERVICES } from './constants'
import { ConnectedService } from './types'

export const NINE_AM_HEALTH_SUCCESS_BANNER_MSG = defineMessage({
  defaultMessage:
    'Welcome to Lyra. We have prefilled your information from 9amHealth and linked {email} to your account.',
  description: 'Success message displayed to inform the user that we have prefilled their information from 9amHealth',
})

export const CONNECTED_SERVICES_ATTESTATION_MSG: Record<ConnectedService, MessageDescriptor> = defineMessages({
  [CONNECTED_SERVICES.NINE_AM_HEALTH]: {
    defaultMessage:
      'By checking this box, I consent to Lyra sharing information relating to my mental health and well-being care with my 9amHealth care team and its providers for the purpose of coordinating my care. This may include questionnaire results (such as mood, anxiety, or stress surveys), whether I completed care, and general progress over time. This consent will expire when my participation in either Lyra services or 9amHealth’s services ends. I understand that I may revoke my consent at any time through the Accounts page in the Lyra app, except to the extent that Lyra has already relied upon it. I also understand that giving this consent is voluntary and not required to receive services from Lyra.',
    description: 'Attestation message for 9amHealth',
  },
})
